import transformFilterModelFromV0ToV1 from './transformFilterModelFromV0ToV1';
export default function transformFilterModelFromV0ToV1IfNotYet(filterModel) {
    if (!filterModel) {
        return [];
    }
    else if (!Array.isArray(filterModel)) {
        return transformFilterModelFromV0ToV1(filterModel);
    }
    else {
        return filterModel;
    }
}
